import React from 'react'
import { firestore } from '../../../../../firebase'

function RemoveUtenlandsProff({proffId, setIsAdded}) {
    
    async function removeProffHandler(e) {
        e.preventDefault()
        try {
            const proffRef = firestore.collection("utenlandsproffer").doc(proffId)
            proffRef.delete()
            setIsAdded(false)
        } catch (error) {
            console.log(error)
        }
    }
    
    return (
        <button className="btn btn-danger btn-block" onClick={removeProffHandler}>Fjern utenlandsproff</button>
    )
}
export default RemoveUtenlandsProff